"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiSettlementRepo = createApiSettlementRepo;
exports.getAll = getAll;
exports.getById = getById;
const ItemList_1 = require("../../../common/models/ItemList");
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
const SettlementMapper_1 = require("./mappers/SettlementMapper");
function createApiSettlementRepo() {
    return {
        getAll,
        getById,
    };
}
async function getAll(page = 1, pageSize = 10, filter = '', startDate = '', endDate = '', sort, machineIds, clubIds) {
    try {
        const sortParam = sort?.length
            ? sort.map((s) => `${s.field},${s.direction}`).join(';')
            : 'orderDate,desc';
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/settlements`),
            params: {
                page,
                pageSize,
                filter,
                startDate,
                endDate,
                sort: sortParam,
                ...(machineIds?.length ? { machineIds } : {}),
                ...(clubIds?.length ? { clubIds } : {}),
            },
        });
        const settElementList = {
            items: res.items.map(SettlementMapper_1.mapToDomainSettlement),
            pagination: res.pagination,
        };
        (0, http_helpers_1.sendSuccessStatus)();
        return settElementList;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function getById(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/settlements/${id}`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return (0, SettlementMapper_1.mapToDomainSettlementDetails)(res);
    }
    catch (error) {
        console.log('error', error);
        (0, http_helpers_1.handleError)(error);
        return {};
    }
}
